"use strict";module.exports={sm:"640px",md:"768px",lg:"1024px",xl:"1200px","2xl":"1440px","3xl":"1600px","4xl":"1920px","5xl":"2660px","6xl":"3440px"};